(() => {
  const waitFor = (getter, interval = 100, maxAttempts = 50) =>
    new Promise((resolve, reject) => {
      let attempts = 0;
      const timer = setInterval(() => {
        const value = getter();
        if (value != null) {
          clearInterval(timer);
          resolve(value);
        } else if (++attempts >= maxAttempts) {
          clearInterval(timer);
          reject(new Error('Webinstats timed out waiting for dataLayer'));
        }
      }, interval);
    });

  const initializeAnalytics = (dataLayer, customerData) => {
    const { pathname } = window.location;
    let pageType = '';
    
    if (pathname === '/') {
      pageType = 'Home';
    } else if (pathname.includes('/collections/')) {
      pageType = 'Collections';
    } else if (pathname.includes('/products/')) {
      pageType = 'Product';
    }

    let customerId, variantId, productId, productTitle, productPrice,
        productVariant, searchKeyword, purchaseAmount, transactionId;
    const purchaseItems = [];

    dataLayer.forEach(i => {
      if (i.length < 2) return;

      const eventName = i[1];
      const payload = i[2];
      
      switch (eventName) {
        case 'view_item':
          if (pageType === 'Product' && payload.items?.length) {
            const item = payload.items[0];
            const parts = item.id.split('_');
            productId      = parts.length > 2 ? parts[2] : item.id;
            variantId      = parts.length > 3 ? parts[3] : item.id;
            productTitle   = item.name;
            productPrice   = item.price;
            productVariant = item.variant;
          }
          break;

        case 'search':
          if (payload.search_term) {
            searchKeyword = payload.search_term;
          }
          break;

        case 'purchase':
          if (payload.value != null) {
            purchaseAmount = payload.value;
            transactionId  = payload.transaction_id;
            pageType       = 'PurchaseSuccess';
          }
          if (Array.isArray(payload.items)) {
            payload.items.forEach(({ id, name, price, quantity, variant }) => {
              purchaseItems.push({ id, name, price, quantity, cat: variant });
            });
          }
          break;

        case 'page_view':
          if (payload.user_data?.email) {
            customerId = payload.user_data.email;
          }
          break;

        default:
          break;
      }
    });

    const loadWiso = (config) => {
      const w = window;
      const src = '//dbfukofby5ycr.cloudfront.net/a9/js/dlc1.67.js';

      if (w.wiso?._execute) {
        w.wiso._execute(true, config);
      } else {
        w.wiso_queue = w.wiso_queue || [];
        w.wiso_queue.push(config);
        if (!w._wisoLoaderInjected) {
          w._wisoLoaderInjected = true;
          const script = document.createElement('script');
          script.async = true;
          script.src   = src;
          document.head.appendChild(script);
        }
      }
    };

    loadWiso({
      s: '4fa5-1733',
      _cburl: '//patyinc.webinstats.com/',
      p: pageType,
      _isexec: 0,
      _runc: (a) => {
        const tracker = ga.getAll()[0].get('name');
        ga(`${tracker}.send`, 'event', 'WIS', 'click', `${a.cn}-${a.n}`, false);
      },
      cuid:           customerData.id || customerId,
      p_customertype: customerData.type || '',
      pid:            productId,
      vid:            variantId,
      pttl:           productTitle,
      pprc:           '',
      pmprc:          productPrice,
      pcatc:          productVariant,
      trid:           transactionId,
      am:             purchaseAmount,
      skw:            searchKeyword,
      adetailmapping: { id: 'id', prc: 'prc', qnt: 'qnt', ttl: 'ttl', cat: 'cat' },
      adetail:        purchaseItems
    });
  };

  waitFor(() => window.dataLayer)
    .then((dl) => initializeAnalytics(dl, customerData))
    .catch(err => console.error('Webinstats analytics init failed:', err));
})();